import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeaderWithBack from '../../components/PageHeaderWithBack';
import OrderProductServicesCart from './components/OrderProductServicesCart';
import OrderManagerApproval from './components/OrderManagerApproval';
import { fetchOrder, OrderResponse } from '../../api/orders';

const ManagerApprovalStandalone: FC = () => {
  const navigate = useNavigate();
  const { orderId } = useParams<{ orderId: string }>();
  const [order, setOrder] = useState<OrderResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!orderId) return;
    let active = true;
    setLoading(true);
    setError(null);
    fetchOrder(orderId)
      .then((o) => {
        if (!active) return;
        setOrder(o);
      })
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load order'))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [orderId]);

  return (
    <div className="mx-auto w-full max-w-[96rem] rounded-[28px] border border-slate-200/70 bg-white/95 p-8 shadow-[0_20px_45px_-32px_rgba(37,40,85,0.55)] min-h-[calc(100vh-220px)]">
      <PageHeaderWithBack
        title={`Manager Approval – ${order?.orderNumber ?? ''}`}
        description="Review cart items, then approve with notes."
        backHref={'/order-management/pending'}
        backLabel="Back to pending orders"
      />

      {error ? <p className="mt-4 text-sm text-danger">{error}</p> : null}
      {loading ? <p className="mt-4 text-sm text-slate-500">Loading…</p> : null}

      <div className="mt-6 space-y-6">
        <section className="rounded-2xl border border-slate-200 bg-white p-4">
          <h3 className="text-base font-semibold text-slate-700">Add Services & Products</h3>
          <div className="mt-3">
            <OrderProductServicesCart
              orderId={orderId ?? null}
              showHeader={false}
              hideContinueButton
              onCompleted={() => {/* stay on page */}}
            />
          </div>
        </section>

        <section className="rounded-2xl border border-slate-200 bg-white p-4">
          <h3 className="text-base font-semibold text-slate-700">Manager Approval</h3>
          <div className="mt-3">
            <OrderManagerApproval
              orderId={orderId ?? null}
              showHeader={false}
              onCompleted={(id) => navigate(`/order-management/${id}`)}
              lockApproverToCurrentUser
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ManagerApprovalStandalone;
